export default {"src":"/_next/static/media/crossWithPawOutline75_40.46d2ce5c.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};